module.exports = __webpack_public_path__ + "img/swyxyy.8671455.png";